(function ($) {
  $(document).ready(function () {
    var photoContributionObj = localizedData.photoContributionScript;
    $("#gallery-contribution-btn").on("click", function (e) {
      var loggedIn = $(this).attr("data-user-logged-in");
      if (!loggedIn) {
        $(".user-login-container").show();
      } else {
        $("#photo-contributor-popup-wrapper").show();
      }
    });

    const fileInput = $("#photo-contribution-upload-form-input");
    const uploadForm = $("#photo-contribution-upload-form");
    const previewContainer = $("#preview-container");
    const uploadStatus = $("#upload-status");
    const dragAndDropArea = $("#drag-and-drop-area");
    const maxFiles = $("#photo-contributor-popup-wrapper").attr(
      "data-photo-limit-left"
    );
    const maxFileSize = 10 * 1024 * 1024;
    const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];

    let allFiles = [];

    // Trigger file input when label is clicked
    dragAndDropArea.on("click", function () {
      if (!fileInput.is(":focus")) {
        fileInput.click();
      }
    });

    // Handle file selection and preview
    function handleFiles(files) {
      let validFiles = [];
      let invalidFiles = [];
      let invalidFileTypes = [];

      if (allFiles.length + files.length > maxFiles) {
        uploadStatus
          .text(
            `You are left with only ${maxFiles} photo upload for this animal`
          )
          .css("color", "red");
        fileInput.val(""); // Clear the input field
        return;
      } else {
        uploadStatus.text(""); // Clear the status message if valid
      }

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > maxFileSize) {
          invalidFiles.push(files[i].name);
        } else if (!allowedFileTypes.includes(files[i].type)) {
          invalidFileTypes.push(files[i].name);
        } else {
          validFiles.push(files[i]);
        }
      }

      if (invalidFiles.length > 0) {
        uploadStatus
          .text(
            `Files namely  ${invalidFiles.join(
              ", "
            )} has exceed the 10 MB each size limit.`
          )
          .css("color", "red");
      }

      if (invalidFileTypes.length > 0) {
        uploadStatus
          .text(
            `Files namely ${invalidFileTypes.join(", ")} has invalid filetype.`
          )
          .css("color", "red");
      }

      if (validFiles.length === 0) {
        fileInput.val(""); // Clear the input field
        return;
      }

      // Append new files to the allFiles array
      allFiles = allFiles.concat(Array.from(validFiles));

      // Clear existing previews and recreate them
      previewContainer.empty();
      allFiles.forEach(function (file, index) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const previewWrapper = $("<div>").addClass("image-preview-wrapper");
          const img = $("<img>").attr("src", e.target.result).css({
            display: "inline-block",
          });

          // Add input for the place name
          const placeInput = $("<input>")
            .attr("type", "text")
            .attr("placeholder", "Enter place name")
            .addClass("place-name-input")
            .attr("data-file-name", file.name); // Bind with the file name

          const cancelBtn = $("<button>")
            .text("X")
            .addClass("cancel-btn")
            .attr("data-file-name", file.name);

          cancelBtn.on("click", function () {
            const fileName = $(this).attr("data-file-name");
            // Find the file by name in the allFiles array
            const fileIndex = allFiles.findIndex((f) => f.name === fileName);
            // Remove the file from allFiles array
            if (fileIndex > -1) {
              allFiles.splice(fileIndex, 1);
            }
            // Remove the preview from the container
            previewWrapper.remove();
          });

          previewWrapper.append(img).append(placeInput).append(cancelBtn);
          previewContainer.append(previewWrapper);
        };
        reader.readAsDataURL(file);
      });
    }

    fileInput.on("change", function () {
      handleFiles(this.files);
      fileInput.val("");
    });

    // Handle drag and drop
    dragAndDropArea.on("dragover", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).addClass("drag-over");
    });

    dragAndDropArea.on("dragleave", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).removeClass("drag-over");
    });

    dragAndDropArea.on("drop", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).removeClass("drag-over");
      const files = e.originalEvent.dataTransfer.files;
      handleFiles(files);
    });

    // Handle form submission with validation for place names
    uploadForm.on("submit", function (e) {
      e.preventDefault();
      if (allFiles.length === 0) {
        uploadStatus
          .text("No files selected. Please select files to upload.")
          .css("color", "red");
        return;
      }

      const formData = new FormData();
      let allValid = true; // Flag to check if all place names are provided

      // Iterate through all files and validate place names
      allFiles.forEach(function (file) {
        const placeName = $(
          `.place-name-input[data-file-name="${file.name}"]`
        ).val(); // Get place name by file name

        // Remove any error styling if place name is valid
        formData.append("files[]", file); // Append file to FormData
        formData.append("place_names[]", placeName); // Append corresponding place name to FormData
      });

      // Stop form submission if any place name is missing
      if (!allValid) {
        return;
      }

      // Additional fields and AJAX request
      var userId = $("#photo-contributor-popup-wrapper").attr("data-user-id");
      var speciesId = $("#photo-contributor-popup-wrapper").attr(
        "data-species-id"
      );

      formData.append("action", "photo_contribution_upload");
      formData.append("nonce", photoContributionObj.photocontribution_nonce);
      formData.append("user_id", userId);
      formData.append("species_id", speciesId);

      // Update status message
      uploadStatus.text("Uploading...").css("color", "black");

      // AJAX call to upload the data
      $.ajax({
        url: photoContributionObj.ajax_url,
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
        success: function (response) {
          if (response.success) {
            uploadStatus
              .text(
                "Files uploaded successfully. It will reflect on the website and your Profile once Approved."
              )
              .css("color", "green");
            clearFormFields();
            previewContainer.empty();
          } else {
            uploadStatus.text("Upload failed: " + response.message);
          }
        },
        error: function (xhr, status, error) {
          console.error("Error:", error);
          uploadStatus.text("Upload failed.");
        },
      });
    });

    function clearFormFields() {
      fileInput.val(""); // Clear file input field
      allFiles = []; // Clear the allFiles array
    }

    // For closing photo contribution pop-up.
    $(document).on(
      "click",
      ".photo-contribution-upload-pop-up-close",
      function () {
        $(this).closest(".npx-popup-wrapper").hide();
      }
    );
  });
})(jQuery);
